import React, { memo } from 'react';
import { generatePath, Navigate, useLocation, useParams } from 'react-router-dom';

interface ILegacyRedirect {
  /** Новый адрес, возможно с параметрами (`/career/skills/:slug`). */
  to: string;
}

/**
 * Переезд со старого карьерного адреса на новый (ТЗ 0069).
 *
 * Три вещи, каждая из которых ломается молча, если её забыть:
 *
 * 1. **Параметры.** `<Navigate to="/career/skills/:slug">` уводит на
 *    ЛИТЕРАЛЬНЫЙ `:slug` — react-router 6.2 подстановку не делает. Поэтому
 *    `generatePath` с параметрами исходного адреса.
 * 2. **Строка запроса и якорь.** `/career/vacancies?skill=17&sort=relevance` из
 *    письма без этого приедет на голый `/career/jobs`, и человек прочитает это
 *    как «ссылка протухла».
 * 3. **`replace`.** Без него «Назад» возвращает на старый адрес, тот снова
 *    редиректит вперёд — и кнопка «Назад» перестаёт работать насовсем.
 *
 * 🔴 Компонент НЕ оборачивается в `MainTemplate`: шаблон монтирует шапку, та
 * заказывает `myCareerCenter`, и всё это размонтируется в том же кадре —
 * пустая шапка мигает, а в сеть уходит лишний запрос на каждый переход по
 * старой ссылке.
 */
export const LegacyRedirect = memo(({ to }: ILegacyRedirect) => {
  const params = useParams();
  const { search, hash } = useLocation();

  return <Navigate replace to={`${generatePath(to, params)}${search}${hash}`} />;
});
